import styled from "styled-components";

export const CheckBox = styled.input`
  transform: scale(${props => props.scale || 1.5});
  margin-left: 3px;
  position: relative;
`
